import React from 'react';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import useQueryParams from 'hooks/useQueryParams';
import TiktokConnectionFlow from 'modules/apps/apps/TiktokApp/components/TiktokConnectionFlow/TiktokConnectionFlow';
import { AccountConnectionFlowContextProvider } from 'components/AccountConnectionFlow/AccountConnectionFlow.provider';

const TiktokAppDrawer = (props) => {
  return (
    <AutomaticDrawer size='large' title='Connect Tiktok Account' width='80%' {...props}>
      <AccountConnectionFlowContextProvider>
        <div className='flex flex-col'>
          <TiktokConnectionFlow />
        </div>
      </AccountConnectionFlowContextProvider>
    </AutomaticDrawer>
  );
};

TiktokAppDrawer.useDrawer = () => {
  const { setUrlParams, removeParams } = useQueryParams();

  const open = () => setUrlParams({ app: 'tiktok' });
  const close = () => removeParams(['app']);

  return {
    open,
    close,
  };
};

TiktokAppDrawer.requiredParams = {
  app: (app) => 'tiktok' === app,
};

TiktokAppDrawer.closeParams = ['connection_batch', 'step'];

export default TiktokAppDrawer;
